import { render } from "./oblissIndex.vue?vue&type=template&id=47c29fe0&scoped=true"
import script from "./oblissIndex.vue?vue&type=script&lang=js"
export * from "./oblissIndex.vue?vue&type=script&lang=js"

import "./oblissIndex.vue?vue&type=style&index=0&id=47c29fe0&lang=less"
import "./oblissIndex.vue?vue&type=style&index=1&id=47c29fe0&scoped=true&lang=css"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c29fe0"]])

export default __exports__